let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9M7fZ")).then(() => parcelRequire('cD4eC'));